module.exports = __webpack_public_path__ + "assets/plus-blue.5da7d4be.svg";